/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author David Hellmann [david@hellmann.io]
 * cards
 */

const cards = {
    cfg:  {
        name: 'cards',
        filter: document.querySelector('.js-cards-filter'),
        indicator: document.querySelector('.js-cards-filterIndicator'),
        select: document.getElementById('js-cards-filterSelect'),
        triggers: document.querySelectorAll('.js-cards-filterTrigger'),
        items: [...document.querySelectorAll('.js-cards-filterItem')],
        initialValue: '0'
    },

    initFilter() {
        this.cfg.initialValue = this.cfg.filter.dataset.init;
        let i = 0;
        let index = 0;

        this.cfg.triggers.forEach((trigger) => {
            // let isData = false;
            const ids = trigger.dataset.id.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.initialValue) {
                    isData = true;
                }
            });

            if (isData || trigger.dataset.id === this.cfg.initialValue) {
                index = i;
            }
            i += 1;
        });

        // const triggers = this.cfg.filter.querySelectorAll('.js-cards-filterTrigger');

        // Main Categories
        this.cfg.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.resetFilter();
                this.setFilter(event, false);
            });
        });

        this.cfg.select.addEventListener('change', (event) => {
            this.resetFilter();
            this.setFilterSelect(event);
        });

        this.cfg.triggers[index].classList.add('is-selected');
        this.cfg.select.value = this.cfg.initialValue;
        // eslint-disable-next-line
        this.cfg.indicator.setAttribute('style',`left:${this.cfg.triggers[index].offsetLeft}px; width:${this.cfg.triggers[index].clientWidth}px`);


        this.cfg.items.forEach((item) => {
            const ids = item.dataset.id.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.initialValue) {
                    isData = true;
                }
            });

            if (isData || this.cfg.initialValue === '*') {
                item.classList.add('is-selected');
            } else {
                item.classList.remove('is-selected');
            }
        });

        // this.resizeAllGridItems();
    },

    setFilter(event, subcategory) {
        event.preventDefault();
        const target = event.currentTarget;

        if (subcategory) {
            // Select MainCategory
        } else {
            target.classList.add('is-selected');
            // eslint-disable-next-line
            this.cfg.indicator.setAttribute('style',`left:${target.offsetLeft}px; width:${target.clientWidth}px`);

            this.cfg.items.forEach((item) => {
                const ids = item.dataset.id.split(',');
                let isData = false;

                ids.forEach((val) => {
                    if (val === target.dataset.id) {
                        isData = true;
                    }
                });

                if (isData || target.dataset.id === '*') {
                    item.classList.add('is-selected');
                } else {
                    item.classList.remove('is-selected');
                }
            });
        }

        // this.resizeAllGridItems();
    },

    setFilterSelect(event) {
        event.preventDefault();

        this.cfg.items.forEach((item) => {
            const ids = item.dataset.id.split(',');
            let isData = false;

            ids.forEach((val) => {
                if (val === this.cfg.select.value) {
                    isData = true;
                }
            });

            if (isData || this.cfg.select.value === '*') {
                item.classList.add('is-selected');
            } else {
                item.classList.remove('is-selected');
            }
        });

        // this.resizeAllGridItems();
    },

    resetFilter() {
        this.cfg.triggers.forEach((trigger) => {
            trigger.classList.remove('is-selected');
        });

        // this.cfg.triggers[0].classList.add('is-selected');

        this.cfg.items.forEach((item) => {
            item.classList.add('is-selected');
        });
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.filter) {
                this.resetFilter();
                this.initFilter();
                // this.resizeAllGridItems();
            }
        });

        window.addEventListener('resize', () => {
            if (this.cfg.filter) {
                // this.resizeAllGridItems();
            }
        });
    }
};

export default cards;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/cards/_script.js